var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailInfo",
              attrs: { title: "LBL0003096", collapsed: true },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _vm.tabParam.councilTitle
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBLTITLE",
                            value: _vm.tabParam.councilTitle,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabParam.councilDate
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003064",
                            value: _vm.tabParam.councilDate,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "grid1",
              attrs: {
                title: "LBL0003077",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.tabParam.imprImmData,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
              },
              on: { linkClick: _vm.immlinkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLADD",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addImprImm },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "grid2",
              staticClass: "q-mt-md",
              attrs: {
                title: "LBLIMPRREQUEST",
                columns: _vm.grid2.columns,
                gridHeight: _vm.grid2.height,
                data: _vm.tabParam.imprData,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
              },
              on: { linkClick: _vm.imprlinkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLADD",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addImpr },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }